import Colors from '@shared/assets/style/default/color';
import Fonts from '@shared/assets/style/default/fonts';
import Screen from '@shared/utils/screen';
import styled from 'styled-components';

const SettingCardTitle = styled.div`
  color: ${Colors['light']};
  font-family: ${Fonts['regular']};
  font-size: ${24 * Screen.widthRatio}px;
  margin-top: ${16 * Screen.widthRatio}px;
  text-align: center;
`;

export default SettingCardTitle;
